import VariablePropertiesJsonSerializer from '../serializers/VariablePropertiesJsonSerializer';
import ExpressionSerializer from '../serializers/ExpressionSerializer';
import { Syntax, TokenVariable } from '@trlogic/ui-pack';
import StructClient from '../client/struct/StructClient';
import GatewayContainer from '../config/GatewayContainer';
import GatewayNames from '../constant/GatewayNames';
import _ from 'lodash';
import DataType from '../constant/DataType';

class ExpressionBridge {
  private readonly structClient: StructClient = GatewayContainer.getInstance().get(GatewayNames.STRUCT_CLIENT);

  private readonly serializer: VariablePropertiesJsonSerializer;
  private readonly expressionSerializer: ExpressionSerializer;

  constructor() {
    this.serializer = new VariablePropertiesJsonSerializer(this.structClient);
    this.expressionSerializer = new ExpressionSerializer(this.serializer);
  }

  public async start(syntax: Syntax, variables: Record<string, TokenVariable[]> = {}) {
    try {
      await this.prepareVariables(variables);
      return await this.expressionSerializer.deserialize(syntax);
    } catch (e) {
      return syntax;
    }
  }

  public async stop(syntax: Syntax) {
    try {
      return await this.expressionSerializer.serialize(_.cloneDeep(syntax));
    } catch (e) {
      console.log(e);
      return syntax;
    }
  }

  public async prepareVariables(variables: Record<string, TokenVariable[]> = {}) {
    if (variables) {
      for (const v of Object.values(variables)) {
        for (const variable of v) {
          if (variable.variable.properties) {
            if (variable.variable.properties.dataType == DataType.DATE) {
              variable.variable.properties = { dataType: DataType.NUMBER };
            } else {
              variable.variable.properties = await this.serializer.deserialize(variable.variable.properties);
            }
          }
        }
      }
    }
  }
}

export default ExpressionBridge;
